import tchat from '@amo/core/assets/images/AMO_Icons/Star.svg';
import { Question } from '@amo/core/components/containers';
import { Radio } from '@amo/core/components/forms';
import _ from 'lodash';
import { Field } from 'redux-form';
import { getTranslation } from '@amo/core/utils/functions.js';

const CrmAuto50Plus3Ans = (props) => {
    const { nextQuestion, data } = props;

    return (
        <Question asFieldset icon={tchat} title={getTranslation('profil.crmMotoMoreThan3.title', { type: 'auto' })}>
            <div className={'row justify-content-center mt-2'}>
                <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                    <Field
                        component={Radio}
                        type={'radio'}
                        name={'DemandeTarif[ListePersonnes][0][CrmAuto50Plus3Ans]'}
                        value={'1'}
                        label={getTranslation('yes')}
                    />
                </div>
                <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                    <Field
                        component={Radio}
                        type={'radio'}
                        name={'DemandeTarif[ListePersonnes][0][CrmAuto50Plus3Ans]'}
                        value={'0'}
                        label={getTranslation('no')}
                    />
                </div>
            </div>

            <button
                className={`btn btn-primary btn-arrow mt-4 ${
                    !_.get(data, 'DemandeTarif[ListePersonnes][0][CrmAuto50Plus3Ans]') && 'disabled'
                }`}
                onClick={() => nextQuestion()}
            >
                {getTranslation('continue')}
            </button>
        </Question>
    );
};

export default CrmAuto50Plus3Ans;
